





























import {Component, Vue} from "vue-property-decorator";

import ApiService from "@/service/ApiService";
import Card from "@/components/Card/Card.vue";

const NAMESPACE_TIME_TRACKING_STATISTICS: string = 'tt/stats';
@Component({
  components: {Card}
})
export default class TimeTrackingStatisticsToday extends Vue {
  public name: string = "TimeTrackingStatisticsToday";

  private apiService: any = new ApiService();
  private statistics: any = {};

  private fetchStatistics(): void {



  }

  private durationFormat(secs: number) {

    return this.$moment.utc(secs * 1000)
        .format('HH:mm:ss');

  }

  created() {

    this.fetchStatistics();

  }


}
